
import ActiveDeactiveDialogConfirmation from 'components/ActiveDeactiveDialogConfirmation'
import { PERMISSION_DENIED_MESSAGE } from '../../constants/index'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable, DataTableValue } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { Tag } from 'primereact/tag'
import { MouseEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContent, toast } from 'react-toastify'
import { addRoleData, getRoleById, getRolesData, roleActiveDeactive, roleUpdate } from 'services/roleService'
import { useDispatch, useSelector } from 'react-redux'
import { handleLoader, handleNotFound } from 'redux/counterSlice'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { datatableEdit, datatableEditHover } from 'assets/icons'
import { Sidebar } from 'primereact/sidebar'
import { InputTextarea } from 'primereact/inputtextarea'
import { useForm } from 'react-hook-form'

const RoleManagement = () => {
    const permissions = useSelector((state: any) => state.persistent.role_permissions);
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        clearErrors
    } = useForm();
    const [roleList, setRoleList] = useState<DataTableValue[]>([])
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [deleteItems, setDeleteItems] = useState<{ for_active: boolean, role_id: [] }>({ for_active: true, "role_id": [] })
    const [selectedProducts, setSelectedProducts] = useState<Record<string, any>>();
    const [activeStatus, setActiveStatus] = useState<boolean>();
    const [is_hover, setIs_hover] = useState<string>("");
    const [is_edit, setIs_edit] = useState<string>("");
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
    const dispatch = useDispatch();

    const fetchRoleData = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getRolesData()
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result?.error
            }
            dispatch(handleLoader(false));
            setRoleList(result)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }


    const getSeverity = (status: string) => {
        switch (status) {
            case 'Active':
                return 'success';

            case 'Inactive':
                return 'warning';
        }
    };


    const onClear = () => {
        setSelectedProducts(undefined);
        setDeleteItems({ for_active: true, "role_id": [] });
        setActiveStatus(false)
    }


    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirst(0);
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        // dispatch(setFirstVoice(0)); // Move to page 1
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };


    const roleActive = (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>, { id, is_active }: { id: number, is_active: boolean }) => {
        // when user clicked on active or inactive icon
        e.stopPropagation();
        setDeleteItems((prevState: any) => ({ ...prevState, for_active: !is_active, role_id: [...prevState.role_id, id] }))
        setActiveStatus(!is_active)
    }

    const roleActiveList = ((is_active: boolean) => {
        // when user clicked on active all and deactive all 
        if (selectedProducts?.length > 0) {
            selectedProducts?.forEach((element: any) => {
                setDeleteItems((prevState: any) => ({ ...prevState, for_active: is_active, role_id: [...prevState.role_id, element.id] }))
            });
            setActiveStatus(is_active)
        } else {
            toast.error("Please select at least one role to update the status", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    })
    const roleActiveChange = async () => {
        // on popup open if yes clicked

        dispatch(handleLoader(true));
        try {
            const { result, error } = await roleActiveDeactive(deleteItems)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            fetchRoleData()
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            onClear()
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }

    }

    // Add-Update Role
    const fetchRoleDatabyId = async (id: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getRoleById(id)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setVisible(true);
            setIs_edit(id);
            setValue("role_name", result.name)
            setValue("description", result.description)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const onSubmit = async (data: { [x: string]: any }) => {
        const createBy = localStorage.getItem("username")
        dispatch(handleLoader(true));
        try {
            if (is_edit === "" && permissions.add) {
                let { result, error } = await addRoleData({ created_by: createBy!, role_name: data?.role_name, description: data?.description })
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
            else if (is_edit !== "" && permissions.edit) {
                let { result, error } = await roleUpdate({ updated_by: createBy, role_id: is_edit, ...data })
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
            setVisible(false);
            setIs_edit("");
            await fetchRoleData();
            dispatch(handleLoader(false));
            setValue("role_name", "");
            setValue("description", "");
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const getFormErrorMessage = (name: string) => {
        return errors[name] && <small className="p-error">{errors[name]?.message?.toString()}</small>
    }


    useEffect(() => {
        dispatch(handleNotFound(false))
        fetchRoleData()
        initFilters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [visible, setVisible] = useState<boolean>(false);
    const onCancel = () => {
        setValue("role_name", "");
        setValue("description", "");
        setVisible(false);
        setIs_edit("");
        clearErrors();
    }
    const customHeader = (
        <div className="flex align-items-center gap-2">
            {is_edit !== "" ? 'Edit' : 'Add'} Role
        </div>
    );

    return (
        <>
            <div className="datatable-wrapper">
                <div className='p-4 content-wrapper'>
                    <div className="switch-section user-management-section">
                        <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                            <h4 className="mb-0">Role Management</h4>
                            <div className="d-flex justify-content-between align-items-center table-right-row">
                                <div className='d-flex align-items-center table-right-first'>
                                    <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                        <IconField iconPosition="right" className='user-input'>
                                            <InputIcon className="pi pi-search"></InputIcon>
                                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by role details" />
                                        </IconField>
                                    </div>
                                    {permissions.add &&
                                        <Button label="Add Role" outlined icon="pi pi-plus" className='outline-icon-btn mr-3 mt-1 mb-1' disabled={!permissions.add}
                                            onClick={() => setVisible(true)}
                                        // onClick={async () => {navigate('/admin/roles/add')}}
                                        ></Button>
                                    }
                                </div>
                                {permissions.delete &&
                                    <div className='table-right-end mt-1 mb-1'>
                                        <Button className='outline-icon-btn grey-outline-btn active-btn mr-3' outlined label='Active' data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={() => { roleActiveList(true) }}></Button>
                                        <Button className='outline-icon-btn grey-outline-btn inactive-btn' outlined label='Inactive' data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={() => { roleActiveList(false) }}></Button>
                                    </div>
                                }
                            </div>
                        </div>
                        <DataTable
                            selection={selectedProducts}
                            selectionPageOnly
                            onSelectionChange={(e) => { setSelectedProducts(e.value) }}
                            paginator
                            filters={filters}
                            globalFilterFields={['name', 'description']}
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            rows={rowsPerPage}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            rowsPerPageOptions={[5, 10, 25]}
                            value={roleList}
                            tableStyle={{}}
                            emptyMessage="No role records found"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="name" header="Role Name" sortable ></Column>
                            <Column field="description" header="Description" sortable></Column>
                            {/* <Column header="Status" dataType="boolean"  body={(rowData) => (<i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.is_active, 'text-red-500 pi-times-circle': !rowData.is_active })}  onClick={(e) => { roleActive(e,rowData) }}></i>)}/> */}
                            <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} body={(rowData) => (<Tag data-bs-toggle={permissions.delete && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={(e) => {
                                permissions.delete ? roleActive(e, rowData) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                    style: {
                                        backgroundColor: '#F1F1F1', // Grey background
                                    }
                                })
                            }} value={rowData.is_active ? 'Active' : 'Inactive'} severity={getSeverity(rowData.is_active ? 'Active' : 'Inactive')} className={rowData.is_active ? 'status-tag active' : 'status-tag inactive'} />)} />
                            <Column header="Action" body={(rowData) => (<span onMouseEnter={() => setIs_hover(rowData.id)} onMouseLeave={() => setIs_hover("")} onClick={(e) => {
                                e.stopPropagation(); permissions.edit ? fetchRoleDatabyId(rowData.id) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                    style: {
                                        backgroundColor: '#F1F1F1', // Grey background
                                    }
                                })
                            }}><img src={is_hover === rowData.id ? datatableEditHover : datatableEdit} alt='edit-icon' /></span>)}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            <ActiveDeactiveDialogConfirmation active={activeStatus!} changeStatus={roleActiveChange} onCancel={onClear} />
            <Sidebar position="right" header={customHeader} visible={visible} onHide={onCancel} className='form-sidebar'>
                <form onSubmit={handleSubmit(onSubmit)} className="group-form">
                    <div className="form-sidebar-body">
                        <div className='form-row'>
                            <div className='form-col'>
                                <label className="form-label">Role Name<i>*</i></label>
                                <InputText  {...register("role_name", { required: { value: true, message: "Role name is required" } })} placeholder="Role Name" />
                                {getFormErrorMessage("role_name")}
                            </div>
                        </div>
                        <div className='form-row'>
                            <div className='form-col'>
                                <label className="form-label">Description<i>*</i></label>
                                <InputTextarea  {...register("description", { required: { value: true, message: "Description is required" } })} placeholder="Add role description here..." />
                                {getFormErrorMessage("description")}
                            </div>
                        </div>
                    </div>
                    <div className='form-sidebar-footer'>
                        <Button className='grey-outline-btn btn-lg' label='Cancel' type='button' onClick={onCancel}></Button>
                        <Button className='outline-active-btn btn-lg' label='Save' type='submit'></Button>
                    </div>
                </form>
            </Sidebar>
        </>
    )
}

export default RoleManagement